var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbUpFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.2501H6.25V26.2501H2.5C2.16848 26.2501 1.85054 26.1184 1.61612 25.884C1.3817 25.6496 1.25 25.3317 1.25 25.0001V12.5001C1.25 12.1686 1.3817 11.8507 1.61612 11.6163C1.85054 11.3818 2.16848 11.2501 2.5 11.2501ZM9.11625 9.63389L17.1163 1.63389C17.2226 1.52726 17.3638 1.4626 17.514 1.4518C17.6642 1.44101 17.8133 1.48481 17.9338 1.57514L19 2.37514C19.2961 2.59745 19.5198 2.90246 19.6428 3.25171C19.7658 3.60096 19.7827 3.97882 19.6913 4.33764L18.25 10.0001H26.25C26.913 10.0001 27.5489 10.2635 28.0178 10.7324C28.4866 11.2012 28.75 11.8371 28.75 12.5001V15.1301C28.7503 15.4568 28.6866 15.7804 28.5625 16.0826L24.6938 25.4764C24.5994 25.7054 24.4391 25.9012 24.2332 26.039C24.0274 26.1768 23.7852 26.2502 23.5375 26.2501H10C9.66848 26.2501 9.35054 26.1184 9.11612 25.884C8.8817 25.6496 8.75 25.3317 8.75 25.0001V10.5176C8.75007 10.1861 8.88181 9.86825 9.11625 9.63389Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpFill);
export default __webpack_public_path__ + "static/media/thumb-up-fill.47952c63.svg";
export { ForwardRef as ReactComponent };